import { Component, OnInit } from '@angular/core';
import { SettingsProvider } from '../_services/settingsProvider.service';

@Component({
  selector: 'corkyy-privacy-policy',
  templateUrl: 'privacy-policy.component.html',
})
export class PrivacyPolicyComponent implements OnInit {
  initialized = false;
  constructor(public settings: SettingsProvider) {}

  ngOnInit(): void {
    this.initialized = true;
  }
}
